import { useMatch } from "react-router-dom";

import {
  parseScopedRouteId,
  SCOPED_ROUTE_PATTERN_LEAGUE,
  SCOPED_ROUTE_PATTERN_ORG,
  SCOPED_ROUTE_PATTERN_PLATFORM,
  type ScopedRouteParams,
} from "@/utils/common/scoped-routes";

export const useScopedRouteParams = (): ScopedRouteParams => {
  // Match most-specific first so a deeper URL doesn't get truncated to a
  // shallower scope. Hooks run unconditionally; we pick the first that matched.
  const leagueMatch = useMatch(SCOPED_ROUTE_PATTERN_LEAGUE);
  const orgMatch = useMatch(SCOPED_ROUTE_PATTERN_ORG);
  const platformMatch = useMatch(SCOPED_ROUTE_PATTERN_PLATFORM);

  const match = leagueMatch ?? orgMatch ?? platformMatch;

  if (!match) {
    return {
      platformId: null,
      organizationId: null,
      leagueId: null,
      isScoped: false,
      restPath: "",
    };
  }

  // `match` is the union of the three patterns, so only `platformId` (shared by
  // all) is on its params type. Read the deeper ids from the specific match that
  // declares them — the org id from the org/league match, the league id from the
  // league match.
  return {
    platformId: parseScopedRouteId(match.params.platformId),
    organizationId: parseScopedRouteId((leagueMatch ?? orgMatch)?.params.organizationId),
    leagueId: parseScopedRouteId(leagueMatch?.params.leagueId),
    isScoped: true,
    restPath: match.params["*"] ?? "",
  };
};
